import { SetStateAction, Dispatch } from 'react'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'

import { useStyles } from './styles'
import { IFilter } from 'src/components/filter/types/filter.types'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { ETranslationNs } from 'src/types'

interface IProps {
  total?: number
  required?: number
  missing?: number
  filter: IFilter
  setFilter: Dispatch<SetStateAction<IFilter>>
}

enum EItemsType {
  All,
  Required,
  Missing,
}

export const Counter = ({ total, required, missing, filter, setFilter }: IProps) => {
  const classes = useStyles()

  const value = filter.onlyMissing
    ? EItemsType.Missing
    : filter.reviewRequired
    ? EItemsType.Required
    : EItemsType.All

  const handleChange = (e: any, value: EItemsType) => {
    if (value === null) return

    if (value === EItemsType.All) {
      setFilter((prev) => ({ ...prev, reviewRequired: false, onlyMissing: false }))
    } else if (value === EItemsType.Required) {
      setFilter((prev) => ({ ...prev, reviewRequired: true, onlyMissing: false }))
    } else {
      setFilter((prev) => ({ ...prev, reviewRequired: false, onlyMissing: true }))
    }
  }

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      size="small"
      onChange={handleChange}
      className={classes.buttonsGroup}
    >
      <ToggleButton value={EItemsType.All}>
        <strong>
          <HelperWrapper t="total-count-title" />
        </strong>
        &nbsp;{total}
      </ToggleButton>
      <ToggleButton value={EItemsType.Required}>
        <strong>
          <HelperWrapper t="translations-table-review-column" ns={ETranslationNs.Common}/>:
        </strong>
        &nbsp;{required}
      </ToggleButton>
      <ToggleButton value={EItemsType.Missing}>
        <strong>
          <HelperWrapper t="missing-translations-toggle-label" />:
        </strong>
        &nbsp;{missing}
      </ToggleButton>
    </ToggleButtonGroup>
  )
}
